/** 「待办」 page: todo/alarm tabs with CRUD, all state from AppState. */
import { useEffect, useState } from 'react';
import { AlarmSection } from '../components/AlarmSection';
import { StatusBanner } from '../components/StatusBanner';
import { TodoSection } from '../components/TodoSection';
import { useApp } from '../state/AppState';

type Tab = 'todos' | 'alarms';

export function TodoPage() {
  const { todos, alarms, settings, network, todoAlarmAvailable, refreshTodos, refreshAlarms } =
    useApp();
  const [tab, setTab] = useState<Tab>('todos');

  // Load both lists once so the tab counts reflect the daemon snapshot even
  // before the user opens the other tab. In live mode wait until the relay is
  // actually connected, otherwise the first request always fails with a
  // transient "relay 尚未连接" banner that would outlive the connection.
  useEffect(() => {
    if (!todoAlarmAvailable) return;
    if (!settings.demoMode && !network.relayConnected) return;
    void refreshTodos();
    void refreshAlarms();
  }, [todoAlarmAvailable, settings.demoMode, network.relayConnected, refreshTodos, refreshAlarms]);

  return (
    <div className="h-full overflow-y-auto">
      <StatusBanner />
      <div className="px-4 pb-2">
        <div className="flex items-start justify-between gap-3">
          <div>
            <h1 className="text-base font-semibold text-slate-100">待办与闹钟</h1>
            <p className="text-[11px] text-slate-500">截止/提醒 · 优先级 · 重复星期 · 删除需确认</p>
          </div>
          {settings.demoMode ? (
            <span className="shrink-0 rounded-full border border-sky-400/30 bg-sky-400/10 px-2 py-0.5 text-[10px] text-sky-200">
              演示数据
            </span>
          ) : null}
        </div>

        <div className="mt-2 grid grid-cols-2 gap-1 rounded-xl border border-white/10 bg-white/[0.03] p-1">
          <button
            type="button"
            onClick={() => setTab('todos')}
            aria-pressed={tab === 'todos'}
            className={`rounded-lg py-1.5 text-xs transition ${
              tab === 'todos' ? 'bg-indigo-500/20 text-indigo-100' : 'text-slate-400'
            }`}
          >
            待办 <span className="text-[10px] text-slate-500">{todos.length}</span>
          </button>
          <button
            type="button"
            onClick={() => setTab('alarms')}
            aria-pressed={tab === 'alarms'}
            className={`rounded-lg py-1.5 text-xs transition ${
              tab === 'alarms' ? 'bg-indigo-500/20 text-indigo-100' : 'text-slate-400'
            }`}
          >
            闹钟 <span className="text-[10px] text-slate-500">{alarms.length}</span>
          </button>
        </div>
      </div>

      <div className="px-4 pb-6">{tab === 'todos' ? <TodoSection /> : <AlarmSection />}</div>
    </div>
  );
}
